import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useDocumentTitle } from 'gossamer-front-end';
import posthog from 'posthog-js';

export const Four04 = (): React.JSX.Element => {
  const location = useLocation();
  React.useEffect(() => {
    console.error(`Soft404: ${location.pathname}`);
    posthog.capture('soft_404', { path: location.pathname });
  }, [location.pathname]);
  useDocumentTitle('Not Found');
  return <div>Not Found</div>;
};
